import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Ourservices from './pages/Ourservices';
import Ourteam from './pages/Ourteam';
import Ourcustomers from './pages/Ourcustomers';
import TrackNavigation from './pages/TrackNavigation';

import Inverterups from './our-services/Inverterups';
import Ledlights from './our-services/Ledlights';
import Lithiumbattery from './our-services/Lithiumbattery';
import Sheetmetal from './our-services/Sheetmetal';

import Boardofdirectors from './investor-relations/Boardofdirectors';
import Committeeofboard from './investor-relations/Committeeofboard';
import Dealersanddistributors from './investor-relations/Dealersanddistributors';
import DetailsofRegistrar from './investor-relations/DetailsofRegistrar';
import Draftredherringprospectus from './investor-relations/Draftredherringprospectus';
import Financials from './investor-relations/Financials';
import Investorgrievance from './investor-relations/Investorgrievance';
import Policiesprogramme from './investor-relations/Policiesprogramme';
import Prospectus from './investor-relations/Prospectus';
import Redherringprospectus from './investor-relations/Redherringprospectus';
import Shareholdingpattern from './investor-relations/Shareholdingpattern';
import Ourjourney from './pages/Ourjourney';
import OnlinePayment from './pages/OnlinePayment';

import DealersandDistributors from './pages/DealersandDistributors';
import Management from './pages/Management';
import Ourinfrastructure from './pages/Ourinfrastructure';
import Bess from './pages/Bess';

function App() {
  return (
    <Router>
       <TrackNavigation /> 
      <div>
        <Navbar/>
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about-us" element={<About />} />
            <Route path="/contact-us" element={<Contact />} />
            <Route path="/our-services" element={<Ourservices />} />
            <Route path="/our-customers" element={<Ourcustomers />} />
            <Route path="/our-team" element={<Ourteam />} />
            <Route path="/investor-relations" element={<Contact />} />

            <Route path="our-services/led-lights" element={<Ledlights />} />
            <Route path="/our-services/lithium-battery" element={<Lithiumbattery />} />
            <Route path="/our-services/inverter-ups" element={<Inverterups/>} />
            <Route path="/our-services/sheet-metal" element={<Sheetmetal />} />

            <Route path="/investor-relations/board-of-directors" element={<Boardofdirectors />} />
            <Route path="/investor-relations/committee-of-board" element={<Committeeofboard />} />
            <Route path="/investor-relations/financials" element={<Financials />} />
            <Route path="/investor-relations/shareholding-pattern" element={<Shareholdingpattern />} />
            <Route path="/investor-relations/policies-programme" element={<Policiesprogramme />} />
            <Route path="/investor-relations/draft-red-herring-prospectus" element={<Draftredherringprospectus />} />
            <Route path="/investor-relations/red-herring-prospectus" element={<Redherringprospectus/>} />
            <Route path="/investor-relations/prospectus" element={<Prospectus />} />
            <Route path="/investor-relations/investor-grievance" element={<Investorgrievance/>} />
            <Route path="/investor-relations/details-of-registrar-and-transfer-agents" element={<DetailsofRegistrar />} />

            <Route path="/dealers-distributors" element={<DealersandDistributors />} />
            <Route path="/our-infrastructure" element={<Ourinfrastructure />} />
            <Route path="/our-management" element={<Management/>}></Route>
            <Route path="/our-journey" element={<Ourjourney />} />
            <Route path="/online-payment" element={<OnlinePayment/>}></Route>

            <Route path="/bess" element={<Bess />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
